import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_disciplines} from "../_signals/s_char";
import {ICharDiscipline} from "../_interfaces/ICharDiscipline";

export interface IDisciplinesAdd {
    id: string, // unique discipline id
    cid: string, // character id
    name: string, // discipline name
    circle: number, // current circle
    num: number, // first, second third...
}

export interface IDisciplinesUpdate {
    id: string, // unique discipline id
    circle: number // only circle, rest not updateable
}

export const DisciplinesCreate = async (create: IDisciplinesAdd): Promise<void> => {
    try {
        const response = await fetch(apiAddress + "/char/disciplines/", createOptions('CREATE', create));
        const data = await response.json();

        console.log('BEDisciplines create response', data);
        s_char_disciplines.value = [...s_char_disciplines.value, data as ICharDiscipline];
    } catch (error) {
        console.error('BEDisciplines create catch', error);
        throw error;
    }
}

export const DisciplinesUpdate = async (update: IDisciplinesUpdate): Promise<void> => {
    try {
        const response = await fetch(apiAddress + "/char/disciplines/", createOptions('UPDATE', update));
        const data = await response.json();

        console.log('BEDisciplines update response', data);
        s_char_disciplines.value = s_char_disciplines.value.map(discipline =>
            discipline.id === update.id
                ? { ...discipline, circle: update.circle }
                : discipline
        );
    } catch (error) {
        console.error('BEDisciplines update catch', error);
        throw error;
    }
}

export const DisciplinesGet = async (cid: string): Promise<void> => {
    try {
        const response = await fetch(apiAddress + "/char/disciplines/" + cid, createOptions('GET'));
        const data = await response.json();

        if (data.hasOwnProperty('result')) {
            console.log('BEDisciplines get result', data.result);
            s_char_disciplines.value = data.result as ICharDiscipline[];
        }
    } catch (error) {
        console.error('BEDisciplines get catch', error);
        throw error;
    }
}